import $x from '@/utils/$x';

export function queryTrainingAdvice(params) {
  return $x.post('/memberTrainingWorkspace/trainingAdvice/query', params, {
    timeout: 10000,
  });
}

export function submitTrainingAdvice(params) {
  return $x.post('/memberTrainingWorkspace/trainingAdvice/submit', params, {
    timeout: 20000,
  });
}
